const ca = {
  nav: {
    services: 'Serveis',
    about: 'Sobre nosaltres',
    references: 'Projectes',
    contact: 'Contacte',
    cta: 'Hola! →',
  },
  hero: {
    kicker: 'Estudi de Disseny & Text',
    tagline: 'Perquè amb nosaltres tens temps per al que importa',
    cta1: 'Parlem →',
    cta2: 'Els nostres Serveis',
    marquee: 'bon disseny i text per a tu de buenas  ·  ',
  },
  intro: {
    kicker: '#bettertogether',
    h2line1: 'Estudi de Disseny & Text',
    h2line2: '',
    subheadline: 'good. better. buenas.',
    p1: "Som Eva · dissenyadora gràfica, Christina · redactora i Agustín · guru IT. I un equip d'experts experimentats en tecnologia i màrqueting online. Estimem el disseny, les paraules i la tecnologia. El món digital i la vida analògica. Escrivim textos que venen, dissenyem i programem branding i disseny web impressionant, contingut per a xarxes socials, anuncis i productes impresos. Per a tots els que busquen l'especial.",
    p2: '',
    p3: '',
    button: 'Més sobre nosaltres →',
  },
  services: {
    kicker: '#buenasideas',
    h2: 'El que fem',
    intro:
      'Combinem disseny gràfic, text i tecnologia. Junts creem experiències de marca i client extraordinàries. Desenvolupem, dissenyem i programem productes i plataformes digitals i analògiques que a més tenen molt bona pinta. Des de la única revista impresa fins al disseny web modern i el programari específic – individual, creatiu i professional.',
    col1: {
      title: 'Disseny Gràfic',
      items: [
        'Identitat Corporativa',
        'Disseny Corporatiu',
        'Disseny de Logo',
        'Disseny Web, App i Pantalla',
        'Disseny Editorial i Impressió',
        'Revistes i Fullets',
        "Disseny d'Anuncis i Contingut",
        "Disseny d'Embalatge",
      ],
      link: 'Saber-ne més →',
    },
    col2: {
      title: 'Textos & Paraules',
      items: [
        'Comunicació Corporativa',
        'Textos Web i App',
        'Storytelling',
        'Textos Publicitaris i de Revista',
        "Textos d'Anuncis i Campanyes",
        'Content Marketing',
        'Eslògans i Claims',
        'Textos SEO',
      ],
      link: 'Saber-ne més →',
    },
    col3: {
      title: 'Software & Desenvolupament',
      items: [
        'Desenvolupament Mobile, Web i App',
        'Productes i Plataformes Digitals',
        'Desenvolupament de Programari',
        'Disseny Responsive',
        'Landing Pages',
        'Llocs Web Corporatius',
        'Interfícies i Bases de Dades',
        'E-Commerce i Botigues Online',
      ],
      link: 'Saber-ne més →',
    },
    panel:
      'Desenvolupament de Marca · Branding · Packaging · Print i Digital · Disseny Web · IA i Programari · Social Media · Content Marketing · Paid Advertising',
  },
  team: {
    kicker: '#buenaspersonas',
    h2: 'Qui som',
    moreLabel: 'saber-ne més',
    lessLabel: 'menys',
    intro:
      "We are young, wild and free – bé, ja no som tan joves. Però almenys encara ens sentim així. Som un grup de creatius que estimen el que fan. L'agència una mica diferent, on cadascú és expert en el seu camp. Som valents, motivats i experimentats. Creatius analògics i digitals. Geeks adorables. Buenas Personas. Pots contractar-nos individualment o com a equip. En línia i sempre personal.",
    eva: {
      role: 'Dissenyadora Gràfica',
      bio: "Si necessites una imatge visual impressionant amb logo i concepte de color: Eva és la nostra experta en gràfica i disseny. Desenvolupa i millora el teu disseny corporatiu i web, els teus mitjans impresos i en línia així com el teu disseny d'embalatge. Li encanten els dissenys nets, reduïts i elegants.",
      more: 'Eva és la germana bessona de Christina, està casada amb el seu amor de joventut i viu amb la seva gata "Happy" a Hard, a la vora del preciós llac de Constança. Viatjar és una de les seves passions, igual que el pàdel, el ioga, l\'art i la cultura. Té una capacitat especial per escoltar i connectar amb les persones. Gràcies a això, crea dissenys únics que encaixen perfectament amb tu i amb els teus productes i tecnologies.',
      badge: 'bon disseny by eva',
      quote: '»El bon disseny és el mínim disseny possible«',
    },
    christina: {
      role: 'Redactora',
      bio: 'Quan et falten les paraules i necessites textos inspiradors i autèntics: Christina és periodista i redactora de formació. Fa més de 15 anys que treballa a la indústria del màrqueting i la comunicació i es va independitzar fa més de 5 anys. Escriu textos i conceptes que emocionen i li apassionen les teves històries.',
      more: "Christina és una pensadora creativa, viatgera i una persona que mira més enllà. L'andorrana per elecció és divertida, tranquil·la i una mica #crazy. Li agrada l'estil de vida del sud, el menjar mediterrani, però també la comoditat austríaca. Es mou molt – jugant pàdel, ioga, senderisme o esquí. Allà és on troba inspiració i idees per escriure.",
      badge: 'bon text by christina',
      quote: '»Escriure és màgia feta visible«',
    },
    agustin: {
      role: 'Desenvolupador de Programari',
      bio: "Si necessites una web o programari: Agustín és el nostre Senior Full-Stack Developer. S'ocupa del teu back-end i front-end i domina eines d'IA així com tots els llenguatges de programació. També és expert en ciberseguretat. En la seva formació gràfica inicial va aprendre el que importa en disseny i usabilitat.",
      more: "Agus no coneix els problemes, sempre pensa en solucions. És argentí i espanyol, viu a Andorra i quan no està programant amb els nostres altres desenvolupadors, el trobaràs a la seva bicicleta de carretera o a la pista de pàdel. Li encanten les coses senzilles de la vida: esport, pizza, pasta, gelat, cafè, sol, cumbia i per descomptat la beguda nacional d'Argentina, el seu mate.",
      badge: 'bones solucions by agus',
      quote: '»No busquis errors, busca solucions«',
    },
    belowCards:
      "… i el nostre equip d'<strong>experts en tecnologia</strong> i <strong>màrqueting en línia</strong>, repartits per tot el món. En línia, però sempre personal.",
  },
  quote: {
    text: "»Sempre hi ha una solució. Troba'n una, crea'n una o pregunta a altres per una.«",
    author: '— Tom Bilyeu',
    cta: "Deixa'ns trobar la teva solució →",
  },
  referenzen: {
    kicker: '#buenasprojects',
    h2: 'Amb qui treballem',
    intro:
      "Treballem amb una gran varietat d'empreses, autònoms, agències i creatius dels sectors més diversos. No pensem en compartiments estancs, sinó que estem oberts a allò nou. Però també a allò provat, les idees disruptives i el pensament sostenible. Seguint el lema: si ho pots imaginar, ho pots fer. Per a empreses, marques, hotels, indústria i lifestyle.",
    moreLink: 'Més Projectes',
    lessLink: 'Mostrar menys',
    badge: 'Amb Winder&Wild',
    placeholder:
      "Les nostres referències i projectes arribaran aviat. N'hi haurà més. (Spoiler: Serà força BUENAS.)",
    projects: [
      {
        name: 'Hotel Birkenhof · Oberstaufen, Allgäu',
        category: 'Brand Design · Disseny Web · Textos Web · Wording · Newsletter',
      },
      {
        name: 'Hotel Helvetia · Lindau, Bodensee',
        category: 'Brand Design · Wording · Merchandising · Brochure · Textos',
      },
      {
        name: 'Physiomed · Eislingen',
        category: 'Brand Design · Logo Design · Papereria Corporativa',
      },
      { name: 'Studio Mint · Maria Jussel', category: 'Veu de Marca · Storytelling · Textos Web' },
      {
        name: 'Damüls Faschina Tourismus',
        category: 'Magazinreihe · Interviews · Texte · Storytelling',
      },
      {
        name: 'Jean & Jacques Manufactura de Gelats',
        category: 'Branding · Disseny · Packaging · Wording · Textos Web',
      },
    ],
  },
  twinPower: {
    kicker: '#goodenergy',
    h2: 'Per què Buenas?',
    text: 'Perquè "Buenas" és més que una salutació. Representa bona energia, bones converses i bona col·laboració. Exactament així és com treballem. Eva, Christina, Agustín i el nostre equip. Ments creatives amb una visió compartida: donem suport a les empreses amb bones idees, bon disseny i bon text. Marques fortes que tenen una veu única.',
    button: 'Hola! Escriu-nos →',
  },
  newsletter: {
    kicker: '#goodnewsonly',
    h2: 'El millor arriba per mail',
    subtext1: "Bones idees i el Buenas-feeling directament a la teva safata d'entrada.",
    subtext2: 'Escrivim sobre disseny, textos, nous projectes i coses que ens inspiren.',
    placeholder: "La teva adreça d'email",
    button: "Subscriure'm →",
    sending: 'Un moment...',
    success: 'Ja hi ets! Aviat rebràs novetats.',
    error: 'Ui – alguna cosa ha sortit malament. Si us plau, torna-ho a intentar.',
    privacy: "En subscriure't acceptes la nostra",
    privacyLink: 'Política de privacitat',
    privacyEnd: '.',
    captchaError: 'Si us plau, verifica que no ets un robot.',
  },
  kontakt: {
    kicker: '#makeitbuenas',
    h2line1: 'Com podem',
    h2line2: 'ajudar-te?',
    subtext1: 'Parlem de la teva marca, la teva idea o el teu projecte.',
    subtext2: 'Prenent un cafè. O en una trucada. O en tots dos.',
    bookingKicker: '#bookwithus',
    bookingTitle: 'Reserva una trucada',
    bookingText: "Tria l'horari que et vagi millor i ens veiem a Zoom.",
    bookingButton: 'Veure disponibilitat →',
    bookingIframeTitle: 'Reserva una trucada amb Buenas Studio',
    bookingOpenNewTab: 'Obrir en una pestanya nova',
    bookingClose: 'Tancar',
    field1: 'El teu Nom',
    field2: 'El teu Email',
    field3: 'La teva Empresa / Projecte',
    field4: "Explica'ns la teva idea…",
    button: 'Enviar →',
    sending: 'Enviant…',
    error: 'Ups – alguna cosa ha anat malament. Escriu-nos directament a hi@buenas-studio.com.',
    captchaError: 'Si us plau, verifica que no ets un robot.',
  },
  danke: {
    back: "← Tornar a la pàgina d'inici",
    kicker: '#hola!',
    title: 'Gràcies pel teu missatge!',
    text: 'Hem rebut la teva sol·licitud i ens posarem en contacte amb tu tan aviat com sigui possible.',
    sub: 'Mentrestant – sent lliure de continuar explorant.',
  },
  impressum: {
    back: "← Tornar a la pàgina d'inici",
    title: 'Avís Legal',
    section1: "Informació segons obligació legal d'informació",
    taxLabel: 'Número fiscal',
    representedBy: 'Representat per',
    responsible: 'Responsable del contingut',
    disclaimer: 'Exempció de responsabilitat',
    liabilityContent: 'Responsabilitat per continguts',
    liabilityContentText:
      "Els continguts del nostre lloc web han estat creats amb la màxima cura. No obstant això, no podem garantir l'exactitud, la integritat i l'actualitat dels continguts. Com a proveïdor de serveis, som responsables dels nostres propis continguts en aquestes pàgines d'acord amb les lleis generals aplicables.",
    liabilityLinks: 'Responsabilitat per enllaços',
    liabilityLinksText:
      'El nostre lloc web conté enllaços a llocs web externs de tercers sobre el contingut dels quals no tenim influència. Per tant, no podem acceptar cap responsabilitat per aquest contingut extern. El proveïdor o operador respectiu de les pàgines és sempre responsable del contingut de les pàgines enllaçades. Les pàgines enllaçades van ser comprovades per possibles infraccions legals en el moment de la vinculació. No es van poder reconèixer continguts il·legals en el moment de la vinculació.',
    copyright: "Drets d'autor",
    copyrightText:
      "Els continguts i obres creats pels operadors del lloc en aquestes pàgines estan subjectes a la llei de drets d'autor. La reproducció, el processament, la distribució i qualsevol tipus d'explotació fora dels límits dels drets d'autor requereixen el consentiment escrit de l'autor o creador respectiu.",
    dispute: 'Resolució de conflictes',
    disputeText:
      "No estem disposats ni obligats a participar en procediments de resolució de conflictes davant d'una junta d'arbitratge de consumidors.",
  },
  datenschutz: {
    back: "← Tornar a la pàgina d'inici",
    title: 'Política de Privadesa',
    date: 'Versió: Març 2026',
    s1h2: "1. Protecció de Dades d'un Cop d'Ull",
    s1h3a: 'Notes Generals',
    s1p1: 'Les notes següents ofereixen una visió general senzilla del que passa amb les vostres dades personals quan visiteu el nostre lloc web. Les dades personals són totes aquelles dades amb les quals podeu ser identificats personalment.',
    s1h3b: 'Recollida de Dades al Nostre Lloc Web',
    s1q1: 'Qui és responsable de la recollida de dades en aquest lloc web?',
    s1a1intro: "L'operador del lloc web és el responsable del tractament de dades:",
    s1q2: 'Com recollim les vostres dades?',
    s1a2: "Les vostres dades es recullen, d'una banda, per vosaltres mateixos en proporcionar-nos-les, per exemple, emplenant el formulari de contacte o subscrivint-vos al butlletí informatiu. Altres dades es recullen automàticament o amb el vostre consentiment quan visiteu el lloc web a través dels nostres sistemes informàtics. Aquestes són principalment dades tècniques (p. ex., navegador d'internet, sistema operatiu o hora d'accés a la pàgina).",
    s1q3: 'Per a què utilitzem les vostres dades?',
    s1a3: "Part de les dades es recullen per garantir el funcionament sense errors del lloc web. Altres dades es poden utilitzar per analitzar el vostre comportament d'usuari, sempre que hàgiu donat el vostre consentiment.",
    s1q4: 'Quins drets teniu sobre les vostres dades?',
    s1a4: "Teniu dret en tot moment a rebre informació gratuïta sobre l'origen, el destinatari i la finalitat de les vostres dades personals emmagatzemades. També teniu dret a sol·licitar la correcció o eliminació d'aquestes dades. Si heu donat el vostre consentiment al tractament de dades, podeu revocar-lo en qualsevol moment amb efecte futur.",
    s1a4b:
      'Per a aquest i altres assumptes relacionats amb la protecció de dades, podeu posar-vos en contacte amb nosaltres en qualsevol moment:',
    s2h2: 'Web Allotjament',
    s2p1: "El nostre lloc web és allotjat per un proveïdor de serveis extern (allotjador). Les dades personals recollides en aquest lloc web s'emmagatzemen als servidors de l'allotjador. Això pot incloure adreces IP, sol·licituds de contacte, metadades i dades de comunicació, dades contractuals, dades de contacte, noms, accessos al lloc web i altres dades.",
    s2p2: "L'allotjador s'utilitza amb la finalitat de complir contractes amb els nostres clients potencials i existents i en benefici d'una provisió segura, ràpida i eficient de la nostra oferta en línia.",
    s3h2: 'Notes Generals i Informació Obligatòria',
    s3h3a: 'Protecció de Dades',
    s3p1: "L'operador d'aquestes pàgines es pren molt seriosament la protecció de les vostres dades personals. Tractem les vostres dades personals de forma confidencial i d'acord amb les disposicions legals de protecció de dades aplicables, en particular la legislació andorrana de protecció de dades (LQPD – Llei Qualificada de Protecció de Dades, 18/2003), així com el Reglament General de Protecció de Dades de la UE (RGPD/GDPR), quan sigui aplicable.",
    s3h3b: 'Responsable del Tractament',
    s3p2: "El responsable del tractament és la persona física o jurídica que, sola o conjuntament amb d'altres, decideix sobre les finalitats i els mitjans del tractament de dades personals.",
    s3h3c: 'Període de Conservació',
    s3p4: "Tret que s'hagi especificat un període de conservació més concret en aquesta política de privadesa, les vostres dades personals romandran amb nosaltres fins que ja no sigui necessari el fi del tractament de dades. Si formuleu una sol·licitud legítima d'eliminació o revoqueu el vostre consentiment per al tractament de dades, les vostres dades seran eliminades, tret que tinguem altres motius legalment admissibles per conservar les vostres dades personals.",
    s3h3d: 'Els Vostres Drets',
    s3rights: [
      "<strong>Dret d'accés</strong> – Podeu sol·licitar informació sobre les vostres dades emmagatzemades amb nosaltres.",
      '<strong>Dret de rectificació</strong> – Podeu sol·licitar la correcció de dades incorrectes.',
      "<strong>Dret de supressió</strong> – Podeu sol·licitar l'eliminació de les vostres dades («dret a l'oblit»).",
      '<strong>Dret a la limitació del tractament</strong> – Podeu sol·licitar la limitació del tractament de les vostres dades.',
      '<strong>Dret a la portabilitat de les dades</strong> – Podeu sol·licitar que us traslladi les vostres dades a vosaltres o a un tercer en format llegible per màquina.',
      "<strong>Dret d'oposició</strong> – Podeu oposar-vos al tractament de les vostres dades personals.",
      '<strong>Dret de retirada del consentiment</strong> – Si el tractament es basa en el vostre consentiment, podeu retirar-lo en qualsevol moment.',
    ],
    s3contact: 'Per exercir aquests drets, poseu-vos en contacte amb nosaltres a:',
    s4h2: '4. Recollida de Dades al Nostre Lloc Web',
    s4h3a: 'Cookies',
    s4p1: "El nostre lloc web utilitza cookies. Les cookies són petits fitxers de text que el vostre navegador emmagatzema al vostre dispositiu. Les cookies ens ajuden a fer la nostra oferta més fàcil d'usar, més efectiva i més segura.",
    s4types: 'Distingim entre:',
    s4cookies: [
      '<strong>Cookies tècnicament necessàries</strong> – Són necessàries per al funcionament del lloc web i no es poden desactivar.',
      "<strong>Cookies d'anàlisi</strong> – Ens ajuden a entendre com interactuen els visitants amb el lloc web. Només s'activen amb el vostre consentiment exprés.",
    ],
    s4p2: 'Quan visiteu el nostre lloc web per primera vegada, un bàner de cookies us demanarà el vostre consentiment. Podeu ajustar les vostres preferències de cookies en qualsevol moment o rebutjar totes les cookies no essencials.',
    s4h3b: 'Fitxers de Registre del Servidor',
    s4logp:
      'El proveïdor del lloc web recull i emmagatzema automàticament informació als anomenats fitxers de registre del servidor, que el vostre navegador ens transmet automàticament. Aquests inclouen:',
    s4logs: [
      'Tipus i versió del navegador',
      'Sistema operatiu utilitzat',
      'URL de referència',
      "Nom d'amfitrió de l'equip que accedeix",
      'Hora de la sol·licitud al servidor',
      'Adreça IP',
    ],
    s4logp2:
      "Aquestes dades no es combinen amb altres fonts de dades. La recollida d'aquestes dades es basa en interessos legítims (Art. 6 apartat 1 lletra f RGPD): el funcionament tècnicament correcte del lloc web.",
    s4h3c: 'Formulari de Contacte',
    s4contactp1:
      'Si ens envieu consultes a través del formulari de contacte, les vostres dades del formulari, incloses les dades de contacte que hàgiu facilitat, seran emmagatzemades per nosaltres amb la finalitat de tramitar la consulta i per al cas de preguntes addicionals. No compartim aquestes dades sense el vostre consentiment.',
    s4contactp2:
      "El tractament d'aquestes dades es basa en l'Art. 6 apartat 1 lletra b RGPD, si la vostra sol·licitud està relacionada amb l'execució d'un contracte o és necessària per a la implementació de mesures precontractuals. En tots els altres casos, el tractament es basa en el nostre interès legítim en la tramitació efectiva de les sol·licituds que ens dirigiu (Art. 6 apartat 1 lletra f RGPD) o en el vostre consentiment (Art. 6 apartat 1 lletra a RGPD).",
    s4storedLabel: 'Dades emmagatzemades:',
    s4storedValue: 'Nom, adreça de correu electrònic, empresa/projecte, contingut del missatge',
    s4retentionLabel: 'Període de conservació:',
    s4retentionValue: 'Fins a la tramitació final de la vostra consulta, màxim 3 anys',
    s5h2: "5. Eines d'Anàlisi",
    s5h3: 'Google Analytics',
    s5p1: "Aquest lloc web utilitza Google Analytics, un servei d'anàlisi web proporcionat per Google Ireland Limited, Gordon House, Barrow Street, Dublín 4, Irlanda («Google»). Google Analytics utilitza cookies que permeten una anàlisi de l'ús que feu del lloc web.",
    s5ipLabel: "Anonimització d'IP:",
    s5ipText:
      "Hem activat la funció d'anonimització d'IP en aquest lloc web. Això significa que la vostra adreça IP serà truncada per Google dins dels estats membres de la Unió Europea o en altres estats contractants de l'Acord sobre l'Espai Econòmic Europeu abans de la seva transmissió als EUA.",
    s5consent:
      "Google Analytics només s'utilitza amb el vostre consentiment exprés a través del nostre bàner de cookies (Art. 6 apartat 1 lletra a RGPD).",
    s5contractLabel: 'Contracte de tractament de dades:',
    s5contractText:
      'Hem subscrit un contracte de tractament de dades amb Google i apliquem íntegrament els estrictes requisits de les autoritats de protecció de dades en utilitzar Google Analytics.',
    s6h2: 'Xarxes Socials',
    s6h3: 'Instagram',
    s6p1: "El nostre lloc web integra contingut de la xarxa social Instagram (Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublín 2, Irlanda). Quan visiteu la nostra pàgina, és possible que s'estableixi una connexió amb els servidors d'Instagram a través del contingut d'Instagram integrat.",
    s6p2: "La integració del contingut d'Instagram es basa en el vostre consentiment (Art. 6 apartat 1 lletra a RGPD) o sobre la base del nostre interès legítim en una presentació atractiva de la nostra oferta en línia (Art. 6 apartat 1 lletra f RGPD).",
    s7h2: 'Butlletí Informatiu',
    s7p1: "Si voleu rebre el butlletí informatiu ofert al lloc web, necessitem la vostra adreça de correu electrònic i la informació que ens permeti verificar que sou el propietari de l'adreça de correu electrònic facilitada i que esteu d'acord amb la recepció del butlletí (procediment de doble opt-in).",
    s7storedLabel: 'Dades emmagatzemades:',
    s7storedValue: 'Adreça de correu electrònic, nom (opcional), data de registre',
    s7purposeLabel: 'Finalitat:',
    s7purposeValue: 'Enviament del butlletí informatiu',
    s7legalLabel: 'Base legal:',
    s7legalValue: 'Consentiment (Art. 6 apartat 1 lletra a RGPD)',
    s7unsubscribe:
      "Podeu cancel·lar la subscripció al butlletí en qualsevol moment a través de l'enllaç de cancel·lació al butlletí o enviant un correu electrònic a hi@buenas-studio.com.",
    s8h2: 'Connectors i Eines',
    s8h3: 'Google Fonts',
    s8p1: 'Aquest lloc utilitza els anomenats Web Fonts per a la visualització uniforme de tipus de lletra, que són proporcionats per Google. En accedir a una pàgina, el vostre navegador carrega els Web Fonts necessaris a la seva memòria cau per mostrar textos i tipus de lletra correctament.',
    s8p2: "L'ús de Google Web Fonts es basa en l'Art. 6 apartat 1 lletra f RGPD. Tenim un interès legítim en la presentació uniforme del tipus de lletra al nostre lloc web.",
    s9h2: 'Canvis en Aquesta Política de Privadesa',
    s9p: "Ens reservem el dret d'adaptar aquesta política de privadesa perquè sempre compleixi amb els requisits legals actuals o per implementar canvis als nostres serveis en la política de privadesa.",
    s10h2: 'Contacte per a Qüestions de Protecció de Dades',
    footernote: 'Buenas Studio · buenas-studio.com · hi@buenas-studio.com · Versió: Març 2026',
  },
  footer: {
    subtitle: 'Estudi de Disseny & Text',
    tagline: 'good. better. buenas.',
    locations: 'Andorra · Àustria · World',
    copyright: '© 2026 Buenas Studio',
    link1: 'Avís Legal',
    link2: 'Política de Privadesa',
  },
  whatsapp: {
    greeting: 'Buenas!',
    text: 'Com podem ajudar-te? Escriu-nos!',
    send: 'Enviar missatge →',
    prefill: 'Hola! Tinc una idea...',
  },
  seo: {
    home: {
      title: 'buenas studio – Estudi de Disseny, Text & Software',
      description:
        "Disseny, text i desenvolupament de software des d'Andorra i el Llac de Constança. Disseny corporatiu, branding, textos, webs i software a mida – creatiu i professional.",
    },
    legal: {
      title: 'Avís Legal – buenas studio',
      description:
        "Avís legal i informació de l'empresa buenas studio. Christina Mathis – Marketing & IT Services, Encamp, Andorra.",
    },
    privacy: {
      title: 'Política de Privacitat – buenas studio',
      description:
        'Política de privacitat de buenas studio. Informació sobre la recollida i el tractament de dades personals.',
    },
    thanks: {
      title: 'Gràcies – buenas studio',
      description:
        'Gràcies pel teu missatge! Ens posarem en contacte amb tu el més aviat possible.',
    },
    notFound: {
      title: 'Pàgina no trobada – buenas studio',
      description: 'Aquesta pàgina no existeix. Torna a la pàgina principal de buenas studio.',
      h1: 'Pàgina no trobada',
      text: 'Ups – aquesta pàgina no existeix.',
      back: "← Tornar a l'inici",
    },
  },
}

export default ca
